import React, { useEffect, useState } from "react";
import { getProfileData } from "../../../service/employerapi";
import { getJobseekerProfileData } from "../../../service/api";

function Header() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!token || !role) return;

      try {
        if (role === "job_seeker") {
          const res = await getJobseekerProfileData();
          setUser(res.data?.data || res.data || {});
        } else if (role === "employer") {
          const res = await getProfileData();
          setUser(res.data?.data || res.data || {});
        }
      } catch (err) {
        console.error("Failed to fetch profile:", err);
      }
    };

    fetchProfile();
  }, [token, role]);

  return (
    <section
      className="headerSection innerheader wow animate__fadeIn"
      data-wow-delay="0.2s"
    >
      <div className="site-width">
        <div className="headerWrapper">
          <div className="logoSection wow animate__fadeInLeft">
            <a href="/employer/home">
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/logoSVG.svg`}
                alt="Hourlee"
                title="Hourlee"
                oncontextmenu="return false;"
              />
            </a>
          </div>
          <div className="headerMain wow animate__fadeInRight">
            <div className="mainHeader">
              <div className="allHeaders wow animate__fadeIn">
                <div className="mainHeaderSection">
                  <div className="headerNav">
                    <ul class="headerMenu">
                      <li class="hasSub megaMenu">
                        <a href="/employer/candidate-list">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/jobs.svg`}
                            alt="chat"
                            style={{ marginRight: "5px" }}
                          />{" "}
                          Find Candidates
                        </a>
                        <div class="headerSubNav">
                          <ul class="headerSubMenu">
                            <li>
                              <h5>Popular Candidates</h5>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">IT jobs</a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">Sales jobs</a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Marketing jobs
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Data Science jobs
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">HR jobs</a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Engineering jobs
                              </a>
                            </li>
                          </ul>
                          <ul class="headerSubMenu">
                            <li>
                              <h5>Candidates in demand</h5>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Fresher jobs
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">MNC jobs</a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">Remote jobs</a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Work from home jobs
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Walk-in jobs
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Part-time jobs
                              </a>
                            </li>
                          </ul>
                          <ul class="headerSubMenu">
                            <li>
                              <h5>Candidates by location</h5>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Delhi
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Mumbai
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Bangalore
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Hyderabad
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Chennai
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Pune
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li class="hasSub ">
                        <a href="/employer/candidate-list">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/explore.svg`}
                            alt="chat"
                            style={{ marginRight: "5px" }}
                          />
                          Top Profiles
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="headerButns">
                <div className="headerRightMenuWrap">
                  <ul className="headerRightMenu headerMenu">
                    {token && role ? (
                      <>
                        {role === "job_seeker" && (
                          <li>
                            <div className="defaultBtn">
                              <a
                                href="/jobseeker/dashboard"
                                className="loginbtn registerBtn d-flex align-items-center gap-2 d-flex"
                                style={{ padding: "3px 20px" }}
                              >
                                <img
                                  src={`${process.env.PUBLIC_URL}/assets/img/user1.jpg`}
                                  alt="User"
                                  style={{ objectFit: "cover" }}
                                />
                                <div>
                                <div className="userName">
                                  {user?.name || "User"}
                                </div>
                                <div className="headerCareer">
                                  Dashboard
                                </div>
                                </div>
                              </a>
                            </div>
                          </li>
                        )}

                        {role === "employer" && (
                          <li>
                            <div className="defaultBtn">
                              <a
                                href="/employer/dashboard"
                                className="loginbtn registerBtn d-flex align-items-center gap-2 d-flex"
                                style={{ padding: "3px 20px" }}
                              >
                                <img
                                  src={`${process.env.PUBLIC_URL}/assets/img/user2.jpg`}
                                  alt="Company"
                                  style={{ objectFit: "cover" }}
                                />
                                <div>
                                <div className="userName">
                                  {user?.companyName || "Employer"}
                                </div>
                                <div className="headerCareer">
                                  Dashboard
                                </div>
                                </div>
                              </a>
                            </div>
                          </li>
                        )}
                      </>
                    ) : (
                      <>
                        <li>
                          <div className="defaultBtn">
                            <a
                              href="/employer/login"
                              className="loginbtn registerBtn"
                            >
                              <span className="headerCareer">Sign In </span>
                            </a>
                          </div>
                        </li>
                        <li>
                          <a href="/">For Jobseekers</a>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="hamburger is-md">
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Header;
